<template>
    <div class="modal_tariff_packet_item_info">
        <div class="modal_tariff_packet_item_info__header">
          <h4 class="title">
            {{ '"' + tariff_packet_item.date + '" ' + tariff_packet_item.name + ' (' + tariff_packet_item.device_fid + ')' }}
          </h4>
        </div>

        <div v-if="loading" style="height: 100%">
          <div class="spinner">
            <scale-loader />
          </div>
        </div>

        <div v-else class="modal_tariff_packet_item_info__content">
          <div class="tab">
            <span
              class="tab_title"
              :class="{ active : block==='MainInfo'}"
              @click="selected_block('MainInfo')"
            >
              {{translate('tariffication.main_info')}}
            </span>

            <span
              v-if="has_packets"
              class="tab_title"
              :class="{ active : block==='TariffPackets'}"
              @click="selected_block('TariffPackets')"
            >
              {{translate('tariffication.tariff_packet.title')}}
            </span>

          </div>
          <div class="block">
            <MainInfo
              v-if="block==='MainInfo'"
              :tariff_packet_item="tariff_packet_item"
            />

            <TariffPackets
              v-if="block==='TariffPackets'"
              :items="tariff_packet_item.items"
            />
          </div>
        </div>

        <div class="modal_tariff_packet_item_info__footer">
          <div class="text-center">
            <span
                v-if="false"
                class="btn btn-success btn-fill btn-wd marginButton"
                @click.prevent="save_change"
            >
                {{ translate('save') }}
            </span>

            <span
              class="btn btn-danger btn-fill btn-wd marginButton"
              @click.prevent="close"
            >
              {{ translate('close_modal') }}
            </span>
          </div>
        </div>
    </div>
</template>
<script>

import MainInfo from "./Tabs/MainInfo.vue";
import TariffPackets from "./Tabs/TariffPackets.vue";

export default {
    name: "TariffPacketItem",
    props: ['tariff_packet_item_id'],
    components: {
      MainInfo,
      TariffPackets
    },

    data() {
        return {
            block: 'MainInfo',
            tariff_packet_item: {},
            options: {
                day: '2-digit',
                month: '2-digit',
                year: 'numeric',
            },
            loading: true,
        }
    },

    created() {
        this.init()
    },

    computed : {
        has_packets(){
            return this.tariff_packet_item.items !==null && this.tariff_packet_item.items.length > 0
        }
    },

    methods: {
        selected_block(block){
            this.block = block
        },
        close() {
            this.$emit('close')
        },
        init() {
            this.$http.v1.getTariffPacketItem(this.tariff_packet_item_id, (response) => {
                this.tariff_packet_item = response.data
                this.loading = false
            })
        },
    }
}
</script>
<style lang="scss" scoped>
.modal_tariff_packet_item_info {
  width: 100%;
  height: 100%;
  border-radius: 3px;
  box-shadow: 0 2px 2px rgba(204, 197, 185, 0.5);
  color: #252422;
  position: relative;
  border: 1px solid #ccc;
  min-height: 85px;
  background-color: #f8f8f8;
  padding: 10px;

  &__header {
    text-align: center;
    height: 5%;
    .title {
      margin-top: 5px;
    }
  }

  &__content {
    height: 88%;
    .tab{
      width: 100%;
      height: 5%;
      display: flex;
      align-content: center;
      justify-content: center;
      flex-direction: row;
      &_title{
        width: 100%;
        padding: 5px 0;
        cursor: pointer;
        font-weight: 600;
        text-align: center;
        background-color: #efe9e9;
        border: 1px solid #efe9e9;
        &.active{
          background-color: #FFFFFF;
          border-bottom: 1px solid white;
        }
      }
    }
    .block{
      height: 95%;
      border: 1px solid #efe9e9;
      margin-top: -1px;
      padding: 10px;
      overflow: auto;
    }
  }

  &__footer{

  }

}


</style>
